import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Input, Label } from 'app/components';
import { getPostValidationError, getPreValidationError } from 'app/utils';
import { FieldRenderProps } from '../DataInputs';

const propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.arrayOf(PropTypes.object),
  dataFields: PropTypes.shape({
    headlight: PropTypes.shape(FieldRenderProps),
    video: PropTypes.shape(FieldRenderProps),
    radio: PropTypes.shape(FieldRenderProps),
    otherTechnic: PropTypes.shape(FieldRenderProps),
    wlan: PropTypes.shape(FieldRenderProps),
    headset: PropTypes.shape(FieldRenderProps),
    mixer: PropTypes.shape(FieldRenderProps),
    technicDescription: PropTypes.shape(FieldRenderProps),
    popcornSmall: PropTypes.shape(FieldRenderProps),
    popcornMedium: PropTypes.shape(FieldRenderProps),
    popcornLarge: PropTypes.shape(FieldRenderProps),
    popcornXlarge: PropTypes.shape(FieldRenderProps),
    softdrink: PropTypes.shape(FieldRenderProps),
    nachosSmall: PropTypes.shape(FieldRenderProps),
    nachosBig: PropTypes.shape(FieldRenderProps),
    otherConcession: PropTypes.shape(FieldRenderProps),
    concessionDescription: PropTypes.shape(FieldRenderProps)
  }).isRequired
};

const defaultProps = {
  errors: []
};

const TechnicConcession = ({
  form,
  errors,
  dataFields: {
    headlight,
    video,
    radio,
    otherTechnic,
    wlan,
    headset,
    mixer,
    technicDescription,
    popcornSmall,
    popcornMedium,
    popcornLarge,
    popcornXlarge,
    softdrink,
    nachosSmall,
    nachosBig,
    otherConcession,
    concessionDescription
  }
}) => {
  const [t] = useTranslation();

  const restrictedCountries = ["hrv"];

  // const handleTechnicTypeChange = useCallback(
  //   item => {
  //     const types = [...technic.input.value];

  //     if (Array.isArray(types)) {
  //       if (types.includes(item)) {
  //         types.splice(types.indexOf(item), 1);
  //       } else {
  //         types.push(item);
  //       }
  //     } else {
  //       types.push(item);
  //     }
  //     form.change(technic.input.name, types);
  //   },
  //   [technic.input.value, form]
  // );

  // const handleConcessionTypeChange = useCallback(item => {
  //   const types = [...concession.input.value];

  //   if (Array.isArray(types)) {
  //     if (types.includes(item)) {
  //       types.splice(types.indexOf(item), 1);
  //     } else {
  //       types.push(item);
  //     }
  //   } else {
  //     types.push(item);
  //   }
  //   form.change(concession.input.name, types);
  // }, [concession.input.value, form]);

  return (
    <div className="cinema-rent__technic-concession-wrapper">
      <div className="cinema-rent__technic-wrapper">
        <h2>{t('cinema_rent_inquiry_form.technic')}</h2>
        <div className="cinema-rent__technic-concession-container">
          <div className="cinema-rent__technic-content">
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Headlight"
                value="Headlight"
                checked={headlight.input.value}
                onChange={e => form.change(headlight.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.headlight')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Video projector"
                value="Video projector"
                checked={video.input.value}
                onChange={e => form.change(video.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.video_projector')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Radio microphone"
                value="Radio microphone"
                checked={radio.input.value}
                onChange={e => form.change(radio.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.radio_microphone')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="otherTechnic"
                value="Other"
                checked={otherTechnic.input.value}
                onChange={e => form.change(otherTechnic.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.other')}</h3>
            </Label>
            <div className="cinema-rent__technic-concession-input">
              <Input
                placeholder={t('cinema_rent_inquiry_form.description_placeholder')}
                id={technicDescription.input.name}
                type="text"
                {...technicDescription.input}
                error={
                  getPreValidationError(technicDescription, t) ||
                  getPostValidationError(errors, technicDescription.input.name, t)
                }
              />
            </div>
          </div>
          {!restrictedCountries.includes(process.env.REACT_APP_COUNTRY) &&
            <div>
              {process.env.REACT_APP_COUNTRY !== "srb" ? (
              <Label className="cinema-rent__technic-concession-checkbox">
                <Checkbox
                  id="WLAN"
                  value="WLAN"
                  checked={wlan.input.value}
                  onChange={e => form.change(wlan.input.name, e.currentTarget.checked)}
                />
                <h3>{t('cinema_rent_inquiry_form.wlan')}</h3>
              </Label>
              ) : null}
              <Label className="cinema-rent__technic-concession-checkbox">
                <Checkbox
                  id="Headset"
                  value="Headset"
                  checked={headset.input.value}
                  onChange={e => form.change(headset.input.name, e.currentTarget.checked)}
                />
                <h3>{t('cinema_rent_inquiry_form.headset')}</h3>
              </Label>
              <Label className="cinema-rent__technic-concession-checkbox">
                <Checkbox
                  id="Mixer"
                  value="Mixer"
                  checked={mixer.input.value}
                  onChange={e => form.change(mixer.input.name, e.currentTarget.checked)}
                />
                <h3>{t('cinema_rent_inquiry_form.mixer')}</h3>
              </Label>
            </div>
          }
        </div>
      </div>
      <div className="cinema-rent__technic-wrapper">
        <h2>{t('cinema_rent_inquiry_form.concession')}</h2>
        <div className="cinema-rent__technic-concession-container-right">
          <div className="cinema-rent__concession-content">
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Popcorn small"
                value="Popcorn small"
                checked={popcornSmall.input.value}
                onChange={e => form.change(popcornSmall.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.popcorn_small')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Popcorn medium"
                value="Popcorn medium"
                checked={popcornMedium.input.value}
                onChange={e => form.change(popcornMedium.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.popcorn_medium')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Popcorn large"
                value="Popcorn large"
                checked={popcornLarge.input.value}
                onChange={e => form.change(popcornLarge.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.popcorn_large')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Popcorn xlarge"
                value="Popcorn xlarge"
                checked={popcornXlarge.input.value}
                onChange={e => form.change(popcornXlarge.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.popcorn_xlarge')}</h3>
            </Label>
          </div>
          <div>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Softdrink 0,5 l bottle"
                value="Softdrink 0,5 l bottle"
                checked={softdrink.input.value}
                onChange={e => form.change(softdrink.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.softdrink')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Nachos small"
                value="Nachos small"
                checked={nachosSmall.input.value}
                onChange={e => form.change(nachosSmall.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.nachos_small')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="Nachos big"
                value="Nachos big"
                checked={nachosBig.input.value}
                onChange={e => form.change(nachosBig.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.nachos_big')}</h3>
            </Label>
            <Label className="cinema-rent__technic-concession-checkbox">
              <Checkbox
                id="otherConcession"
                value="Other"
                checked={otherConcession.input.value}
                onChange={e => form.change(otherConcession.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.other')}</h3>
            </Label>
            <div className="cinema-rent__technic-concession-input">
              <Input
                placeholder={t('cinema_rent_inquiry_form.description_placeholder')}
                id={concessionDescription.input.name}
                type="text"
                {...concessionDescription.input}
                error={
                  getPreValidationError(concessionDescription, t) ||
                  getPostValidationError(errors, concessionDescription.input.name, t)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TechnicConcession.propTypes = propTypes;
TechnicConcession.defaultProps = defaultProps;

export default memo(TechnicConcession);
